<template>
  <v-container fluid>
    <v-row>
      <v-toolbar height="72" style="position: fixed; z-index: 2; width: 100%">
        <v-col
          style="flex: 0 0 20%; max-width: 20%"
          class="d-flex justify-space-between px-0"
        >
          <XsLoginButton />
          <XsRewardsButton
            v-if="authorized && includeLoyalty && (hasClubs || hasPoints)"
          />
        </v-col>
        <v-col
          style="flex: 0 0 60%; max-width: 60%"
          class="align-center d-flex justify-center px-0"
        >
          <h1
            class="color-black-magic font-size-sm font-weight-semibold text-uppercase"
          >
            {{ wait(storeInfo, "name") }}
          </h1>
        </v-col>
        <v-col
          style="flex: 0 0 20%; max-width: 20%"
          class="d-flex justify-space-around px-0"
        >
          <div class="position-relative" v-if="!rewardsFormat">
            <v-btn fab x-small :to="{ name: 'about' }">
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </div>
          <div class="position-relative" v-if="!rewardsFormat">
            <Badge />
            <XsCartButton />
          </div>
        </v-col>
      </v-toolbar>
    </v-row>
    <v-row style="margin-top: 90px" v-if="!rewardsFormat">
      <v-col class="d-flex justify-center">
        <BannerCarousel :mobile="true" />
      </v-col>
    </v-row>
    <v-row v-if="!rewardsFormat">
      <v-col>
        <InactiveXsSearch />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { formatAddress, formatPhoneNumber, wait } from "@/util.js";
import Badge from "@/components/UI/Badge.vue";
import InactiveXsSearch from "@/components/Search/Xs/Inactive.vue";
import XsCartButton from "@/components/Auth/Buttons/Xs/Cart.vue";
import XsLoginButton from "@/components/Auth/Buttons/Xs/Login.vue";
import BannerCarousel from "@/components/BannerCarousel/BannerCarousel.vue";
import XsRewardsButton from "@/components/Auth/Buttons/Xs/Rewards.vue";

export default {
  name: "XsHomeCarouselHeader",
  components: {
    XsRewardsButton,
    BannerCarousel,
    Badge,
    InactiveXsSearch,
    XsCartButton,
    XsLoginButton,
  },
  computed: {
    ...mapGetters("auth", { authorized: "isAuthenticated" }),
    ...mapGetters("store", {
      hasPoints: "hasPoints",
      hasClubs: "hasClubs",
      rewardsFormat: "rewardsFormat",
    }),
    ...mapState({
      storeInfo: (state) => state.store.info,
      slogan: (state) =>
        state.store.info.store_info.customization?.website.style.slogan,
    }),
  },
  data() {
    return {
      includeLoyalty:
        process.env.VUE_APP_INCLUDE_LOYALTY.toLowerCase() === "true",
    };
  },
  methods: {
    formatAddress,
    formatPhoneNumber,
    wait,
  },
};
</script>
